import { ethers } from "ethers";

export const hexToDecimal = hex => parseInt(hex, 16); 
export const formatNumber = (number, decimalPrecision = 2) => new Intl.NumberFormat('en-US', { maximumSignificantDigits: decimalPrecision }).format(number)
export const toEtherValue = (wei) => ethers.utils.formatEther(wei);
export const toWeiValue = (ether) => ethers.utils.parseEther(ether);